// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tPy4","index":"styles_index__22PnR"};